// extracted by mini-css-extract-plugin
export default {"container":"Login_container__gzyTT","login__button":"Login_login__button__GBruP","registerLink__button":"Login_registerLink__button__dSyJH","form":"Login_form__fnHwX"};